@if (isLoading()) {
  <div class="flex justify-center items-center h-64">
    <mat-spinner diameter="48" />
  </div>
} @else {
  <div class="p-5">
    <app-breadcrumb [items]="breadcrumbItems()" />

    <div class="flex justify-between items-center mb-5">
      <h1 class="text-2xl font-medium">{{ 'waters.information.breadcrumb' | translate }}</h1>
      <div class="flex gap-2">
        <button mat-stroked-button [disabled]="isSaving()" (click)="cancel()">
          {{ 'waters.form.cancel' | translate }}
        </button>
        <button mat-flat-button color="primary" [disabled]="isSaving()" (click)="save()">
          @if (isSaving()) {
            <mat-spinner diameter="18" />
          } @else {
            {{ 'waters.form.save' | translate }}
          }
        </button>
      </div>
    </div>

    <mat-tab-group animationDuration="0ms">

      <mat-tab [label]="'waters.information.tab.general' | translate">
        <app-water-information-general-section
          [form]="generalForm"
          [appHeaderPhotoName]="appHeader().name"
          [appHeaderPhotoUrl]="appHeader().url"
          [ambianceVideoImageName]="ambiancePoster().name"
          [ambianceVideoImageUrl]="ambiancePoster().url"
          [expectations]="expectations()"
          (expectationsChange)="expectations.set($event)"
          (uploadImage)="selectInfoImage($event.type, $event.file)"
          (deleteImage)="clearInfoImage($event)"
        />
      </mat-tab>

      <mat-tab [label]="'waters.information.tab.content-blocks' | translate">
        <app-water-information-content-blocks-section
          [contentBlocks]="contentBlocks()"
          (contentBlocksChange)="contentBlocks.set($event)"
          (blockImageSelected)="onBlockImageSelected($event)"
          (blockImageCleared)="onBlockImageCleared($event)"
        />
      </mat-tab>

      <mat-tab [label]="'waters.information.tab.pricing' | translate">
        <app-water-information-pricing-section
          [form]="pricingForm"
          [priceLabels]="priceLabels()"
          (priceLabelsChange)="priceLabels.set($event)"
        />
      </mat-tab>

      <mat-tab [label]="'waters.information.tab.hotspots' | translate">
        <app-water-information-hotspots-section
          [introductionForm]="hotspotIntroductionForm"
          [hotspots]="hotspots()"
          (hotspotsChange)="hotspots.set($event)"
          (hotspotImageSelected)="onHotspotImageSelected($event)"
          (hotspotImageCleared)="onHotspotImageCleared($event)"
        />
      </mat-tab>

      <mat-tab [label]="'waters.information.tab.location' | translate">
        <app-water-information-location-section
          [form]="locationForm"
          [mapImageName]="mapImage().name"
          [mapImageUrl]="mapImage().url"
          [locationImageName]="locationImage().name"
          [locationImageUrl]="locationImage().url"
          (uploadImage)="selectInfoImage($event.type, $event.file)"
          (deleteImage)="clearInfoImage($event)"
        />
      </mat-tab>

      <mat-tab [label]="'waters.information.tab.seo' | translate">
        <app-water-information-seo-section [form]="seoForm" />
      </mat-tab>

    </mat-tab-group>
  </div>
}
